"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unwrap = unwrap;
// Only ASCII whitespace is source formatting; a deliberate non-breaking space survives.
const FORMATTING_WHITESPACE = /[ \t\n\r\f\v]+/g;
const PARAGRAPH_BREAK = /\n(?:[ \t\r\f\v]*\n)+/;
/**
 * Tag for prose wrapped across source lines: wrapping and indentation collapse
 * to single spaces, and a blank line becomes a paragraph break ("\n\n").
 * Interpolated values are treated as template text, so unwrapped output can be
 * interpolated into another unwrap without losing its paragraphs.
 */
function unwrap(strings, ...values) {
    // A chunk with an invalid escape (e.g. `C:\users`) has no cooked value, so fall back to raw.
    const cooked = strings;
    const text = cooked.reduce((acc, chunk, i) => acc + (chunk ?? strings.raw[i]) + (i < values.length ? String(values[i]) : ""), "");
    return text
        .split(PARAGRAPH_BREAK)
        .map((paragraph) => paragraph.replace(FORMATTING_WHITESPACE, " ").replace(/^ | $/g, ""))
        .filter((paragraph) => paragraph !== "")
        .join("\n\n");
}
//# sourceMappingURL=unwrap.js.map